import axios from 'axios';
export const api = buildApi();

export function buildApi(extraPath = '') {
    const root = window.location && window.location.origin;
    const apiUrl = root.replace(/\/$/, '');
    extraPath = extraPath.replace(/^\//, '');

    return axios.create({
        baseURL: `${apiUrl}/${extraPath}`,
    });
}

export const locationsApi = buildApi('/wp-json/wp/v2/location');



// WEBPACK FOOTER //
// ./src/includes/api.js